'use strict';
import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Plans = {

    async getById(planID) {
        try {
            if (!planID) {
                return { error: "Plan ID is missing" }
            }

            let header = await getHeader();
            
            let response = await axios.get(API_URL + '/plan/' + planID, header);

            return response.data;

        } catch (error) {
            return false;
        }
    },

    async updatePlatinumLimits(userID, planID, artworkLimit, pushNotificationLimit, pushNotificationRecipientLimit, catalogUserLimit) {
        try {
            if (!userID || !planID || !artworkLimit || !pushNotificationLimit || !pushNotificationRecipientLimit || !catalogUserLimit) {
                return { error: "A mandatory field is missing" }
            }

            let header = await getHeader();

            let response = await axios.patch(API_URL + '/plan/' + planID, {
                "userId": userID,
                "planType": "Platinum",
                "artworkLimit": parseInt(artworkLimit),
                "pushNotificationLimit": parseInt(pushNotificationLimit),
                "pushNotificationRecipientLimit": parseInt(pushNotificationRecipientLimit),
                "catalogUserLimit": parseInt(catalogUserLimit)
            }, header);

            return response.data;

        } catch (error) {
            return false;
        }
    }

}

export default Plans;